<template>
  <div class="has-background-light is-border-top">
    <div id="mapVue">
      <program-map
        class="is-margin-bottom-xlarge"
        ref="map"
        :source="program"></program-map>
    </div>
    <cta-to-promoteur
      class="is-sticky--bottom is-margin-left-auto is-margin-right is-margin-top"
      @clickOnCta="$emit('openModalTicket');"></cta-to-promoteur>
  </div>
</template>

<script>
import { DefaultValues } from '@/mixins'
import CtaToPromoteur from '@/components/utils/CtaToPromoteur'

export default {
  name: 'ProgramMapTab',
  components: {
    ProgramMap: () => import('../ProgramMap'),
    CtaToPromoteur
  },
  mixins: [DefaultValues],
  props: {
    program: {
      required: true
    }
  },
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>
